// extracted by mini-css-extract-plugin
module.exports = {"container":"infoBlue_container__2TPmT"};